import {
  SubscriptionsService,
  type SubscriptionDetailResponse,
} from '@/services/subscriptions.service';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useSubscriptionDetails(publicId?: string) {
  const queryClient = useQueryClient();

  const detailQuery = useQuery({
    queryKey: ['subscription-detail', publicId],
    queryFn: () => SubscriptionsService.getSubscriptionDetail(publicId!),
    enabled: Boolean(publicId),
  });

  const cancelMutation = useMutation({
    mutationFn: () => SubscriptionsService.cancelSubscription(publicId!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subscription-detail', publicId] });
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    },
  });

  return {
    detail: detailQuery.data as SubscriptionDetailResponse | undefined,
    isLoading: detailQuery.isLoading,
    isError: detailQuery.isError,
    refetch: detailQuery.refetch,
    cancelSubscription: cancelMutation.mutateAsync,
    isCanceling: cancelMutation.isPending,
  };
}
